// extracted by mini-css-extract-plugin
module.exports = {"FloatingMenu":"FloatingMenuContainer_FloatingMenu__3zPdv"};